module.exports = __webpack_public_path__ + "static/media/ratting-app.ae55510a.jpg";